{
    "SortAsc1Label": "1. aufsteigend",
    "SortDsc1Label": "1. Absteigend",
    "SortAsc2Label": "2. aufsteigend",
    "SortDsc2Label": "2. Absteigend",
    "SortAsc3Label": "3. aufsteigend",
    "SortDsc3Label": "3. Absteigend",
    "SortNoneLabel": "[Nicht sortiert nach]",
    "SortAsc1Tooltip": "Berichtszeilen primär aufsteigend nach der ausgewählten Statistik\/Feld sortieren.",
    "SortDsc1Tooltip": "Berichtszeilen primär absteigend nach der ausgewählten Statistik\/Feld sortieren.",
    "SortAsc2Tooltip": "Sekundär aufsteigend nach der ausgewählten Statistik\/Feld sortieren.",
    "SortDsc2Tooltip": "Sortieren Sie sekundär absteigend nach der ausgewählten Statistik\/Feld.",
    "SortAsc3Tooltip": "Berichtszeilen 3. aufsteigend nach der ausgewählten Statistik\/Feld sortieren.",
    "SortDsc3Tooltip": "Berichtszeilen 3. absteigend nach der ausgewählten Statistik\/Feld sortieren.",
    "SortNoneTooltip": "Berichtszeilen nicht nach der ausgewählten Statistik\/Feld sortieren.",
    "NAME": "SortList"
}